import React from 'react'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import Modal, { Body, Footer, Header } from 'src/components/theme/Models/Modal'

interface DeleteModalProps {
  isOpen: boolean
  toggle: () => void
  onDelete: () => Promise<void>
  isLoading: boolean
}

const DeleteModal: React.FC<DeleteModalProps> = ({ isOpen, toggle, onDelete, isLoading }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} title='Delete Report'>
      <Header title='Delete Report' />
      <Body error={{ error: '', show: false }}>
        <p>Are you sure you want to delete this report?</p>
      </Body>
      <Footer
        toggle={toggle}
        action={{
          text: 'Delete',
          icon: faTrash,
          color: 'danger',
          disabled: isLoading,
          onAction: onDelete
        }}
      />
    </Modal>
  )
}

export default DeleteModal
